(function mSelect() {
    let $mSelects = $('.m-select');
    $mSelects.each((i, root) => {
        const $root = $(root);
        const inputId = $root.attr('data-input-id');
        const $input = $('#' + inputId);
        const $value = $root.find('.value');
        const $valueSpan = $root.find('.value-span');
        const $options = $root.find('.option');
        let $selectedOption = $root.find('.selected');

        let focusedOptionIndex = -1;
        
        onInput();
        $input.on('input', onInput);

        function update($selected) {
            if ($selected.length) {
                $selectedOption.removeClass('selected');
                $selectedOption = $selected;
                $selectedOption.addClass('selected');
                const valueLabel = $selectedOption.attr('data-value-label');
                $valueSpan.text(valueLabel);
            }
        }

        function getSelectedOption() {
            const value = $input.val();
            const $selected = $root.find(`[data-value="${ value }"]`);
            return $selected;
        }

        function onInput() {
            update(getSelectedOption());
        }

        function toggleDropdown({ forceHide = false, restoreFocus = true } = {}) {
            let open = $root.hasClass('open');
            let willHide = open;
            if (forceHide) {
                willHide = true;
            }

            if (willHide && restoreFocus) {
                $value.focus();
            }
            if (!willHide) {
                let $selected = getSelectedOption();
                $selected.focus();
                focusedOptionIndex = $options.index($selected);
            }

            $root.toggleClass('open', !willHide);
        }

        function chooseOption($selected) {
            const value = $selected.attr('data-value');
            $input.val(value).trigger('input');
            toggleDropdown({ forceHide: true });
            update($selected);
        }

        function navigateOptions({ by, to } = {}) {
            to = to != null ? to : focusedOptionIndex + by;
            focusedOptionIndex = to;
            let n = $options.length;
            focusedOptionIndex = (focusedOptionIndex + n) % n;
            
            let $selected = getSelectedOption();
            $selected.removeClass('selected');
            let $focused = $($options.get(focusedOptionIndex));
            $focused.focus();
        }
        
        function handleClick(event) {
            const withinOptions = $(event.target).closest('.options').length > 0;
            if (!withinOptions) {
                toggleDropdown();
            } else {
                const $selected = $(event.target);
                if ($selected.hasClass('option')) {
                    chooseOption($selected);
                }
                // let $selected = $($options.get(focusedOptionIndex));
                // chooseOption($selected);
            }
        }

        $root.on('click', (event) => {
            handleClick(event);
        });

        // $root.find('.option').on('click', (event) => {
        //     const $selected = $(event.target);
        //     chooseOption($selected);
        // });
            
        $root.on('keydown', (event) => {
            switch (event.key) {
                case ' ':
                    event.preventDefault();
                    handleClick(event);
                    break;
                case 'Enter':
                    event.preventDefault();
                    handleClick(event);
                    break;
                case 'Tab':
                    toggleDropdown({ forceHide: true, restoreFocus: false });
                    break;
                case 'ArrowDown':
                    event.preventDefault();
                    navigateOptions({ by: 1 });
                    break;
                case 'ArrowUp':
                    event.preventDefault();
                    navigateOptions({ by: -1 });
                    break;
            }
        });

        $(document).on('click', (event) => {
            const withinSelect = $(event.target).closest($root).length > 0;
            if (!withinSelect) {
                toggleDropdown({ forceHide: true, restoreFocus: false });
            }
        });
    });
})();